import { Router } from '@remix-run/router';
import React, { createContext, useCallback } from 'react';
import { useDispatch, useSelector } from 'react-redux';

import { modals } from '../../../config/modal.config';
import { RootState } from '../../../store';
import { closeModal } from '../../reducers';

const modalSelector = ({ modal }: RootState) => modal;

type Props = {
  router: Router;
};

export const ModalContext = createContext({} as Router);

const RootModal: React.FC<Props> = ({ router }) => {
  const dispatch = useDispatch();
  const { modalDlg } = useSelector(modalSelector);

  const onClose = useCallback(() => dispatch(closeModal()), [dispatch]);

  if (modalDlg === null) {
    return null;
  }

  const Modal = modals[modalDlg.type];
  return (
    <ModalContext.Provider value={router}>
      <Modal context={modalDlg.context} onClose={onClose} />
    </ModalContext.Provider>
  );
};

export { RootModal };
